module.exports = __webpack_public_path__ + "static/media/arrow_circle_right.cd144fb9.svg";